import { Injectable } from '@angular/core';
import _ from 'lodash';
import moment from 'moment-timezone';

declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  toQueryString(paramsObject: any, removeNullOrEmpty: boolean = true): string {
    let result: string = '';
    if (removeNullOrEmpty) paramsObject = this.removeNullOrEmpty(paramsObject);

    if (paramsObject) {
      result = Object
        .keys(paramsObject)
        .map((key: string) => {
          if (_.isArray(paramsObject[key])) {
            return paramsObject[key].map((innerKey: string) => `${encodeURIComponent(key)}=${encodeURIComponent(innerKey)}`)
              .join('&');
          }

          else if (_.isObject(paramsObject[key])) {
            const innerKeys = Object.keys(paramsObject[key]);
            return innerKeys.map(
              innerKey => {
                if (_.isArray(paramsObject[key][innerKey]))
                  return paramsObject[key][innerKey].map((ikey: string, i: number) =>
                    `${encodeURIComponent(key)}[${encodeURIComponent(innerKey)}][${i}]=${encodeURIComponent(paramsObject[key][innerKey][i])}`)
                    .join('&');
                else
                  return `${encodeURIComponent(key)}[${encodeURIComponent(innerKey)}]=${encodeURIComponent(paramsObject[key][innerKey])}`;
              }
            ).join('&');
          }

          else {
            return `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`;
          }
        })
        .join('&');
    }

    return (result as any).split('&').map((el: any) => el.split('=')).filter((el: any) => el[1] != 'undefined').map((el: any) => el.join('=')).join('&');
  }

  random(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  date = {

    tz() {
      return moment.tz.guess();
    },

    localeToUTC(value: string) {
      const date = this.toLocale(value);
      return this.toUTC(date);
    },

    localeStartOfDay(date?: any) {
      const timezone = moment.tz.guess();
      const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
      return moment(date).tz(timezone).startOf('day').utc().format(format);
    },

    localeEndOfDay(date?: any) {
      const timezone = moment.tz.guess();
      const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
      return moment(date).tz(timezone).endOf('day').utc().format(format);
    },

    toUTC(value: string) {
      const format = "YYYY-MM-DDTHH:mm";
      return moment.utc(value).format(format);
    },

    toUTCDateOnly(value: string) {
      const format = "YYYY-MM-DD";
      return moment.utc(value).format(format);
    },

    ISOtoLocaleDate(value: string) {
      return moment(value).format("YYYY-MM-DD")
    },

    toLocale(value: string) {
      if (moment(value).isValid()) {
        const timezone = moment.tz.guess();
        const format = "YYYY-MM-DDTHH:mm:ss";
        return moment.tz(value, timezone).format(format);
      }
      return value;
    },

    addHours(value: string, hours: number) {
      if (moment(value).isValid()) {
        return moment(value).add(hours, 'hours');
      }
      return;
    },

    addDays(value: string, days: number) {
      if (moment(value).isValid()) {
        return moment(value).add(days, 'days');
      }
      return;
    }
  }

  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }

  blobToObjectURL(data: any, type: string): string {
    const blob = new Blob([data], { type: type });
    return window.URL.createObjectURL(blob);
  }

  removeNullOrEmpty(data: any): any {

    // si data es un array, retornar [removeNullOrEmpty(cada item)].filter(empty)
    if (_.isArray(data)) return data
      .map((item: any) => this.removeNullOrEmpty(item))
      .filter(item => (
        (_.isObject(item) && Object.keys(item).length !== 0) ||
        (!_.isObject(item) && (item !== undefined && item !== ''))
      ));

    // si data es un objeto, por cada propiedad: si es objeto, llamar recursivamente. 
    // luego, limpiar valores
    /*
    if (_.isObject(data)) {
      Object.keys(data).forEach((key: any) => { data[key] = this.removeNullOrEmpty(data[key]); });
      return _.omitBy(data, v => v === undefined || v === '' || (_.isObject(v) && Object.keys(v).length === 0));
    }
      */
    if (_.isObject(data)) {
      const dataObj = data as Record<string, any>;
      Object.keys(dataObj).forEach((key) => {
        dataObj[key] = this.removeNullOrEmpty(dataObj[key]);
      });
      return _.omitBy(dataObj, v => v === undefined || v === '' || (_.isObject(v) && Object.keys(v).length === 0));
    }

    // si data no es array ni objeto, devolver data
    return data;
  }

  getPath() {
    return window.location.href;
  }

  getLastPartPath() {
    const txt: any = this.getPath().split('?')[0];
    return txt.substring(txt.lastIndexOf('/') + 1);
  }

  /*
  getQueryParams() {
    const querystring = this.getPath().split('?')[1];
    console.log('querystring', querystring);
    const params = {};
    querystring.split('&').forEach((el) => {
      const [key, val] = el.split('=');
      params[key] = decodeURIComponent(val);
    });
    console.log('params', params);
    return params;
  } 

  getQueryParam(param) {
    const value = this.getQueryParams()[param];
    console.log('value', value);
    return value;
  }*/

  padTo2Digits(num: any) {
    return num.toString().padStart(2, '0');
  }

  convertMsToHM(ms: number, showSeconds = true) {
    var d, h, m, s, result = '';
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;
    h += d * 24;

    if (h !== 0) {
      if (h.toString().length == 1) h = '0' + h;
      result += h + ':';
    } else result += '00:';

    if (m !== 0) {
      if (m.toString().length == 1) m = '0' + m;
      if (showSeconds) {
        result += m + ':';
      } else {
        result += m;
      }
    } else {
      if (showSeconds) {
        result += '00:';
      } else {
        result += '00'
      }
    }

    if (showSeconds) {
      if (s !== 0) {
        if (s.toString().length == 1) s = '0' + s;
        result += s;
      } else result += '00';
    }
    return result.split('NaN').join('00');

  }
}

export function roundNum(num: string | number, decimals: number = 2): number {
  let stringValue = num.toString();
  num = parseFloat(stringValue);
  num = isNaN(num) ? 0 : num;
  decimals = decimals > 0 ? (10 ** decimals) : 1;
  return Math.round(num * decimals) / decimals;
}